module.exports = __webpack_public_path__ + "img/14_l_no.96094733.svg";